import { useState } from "react";
import { Lock } from "lucide-react";
import { useTranslation } from "../i18n/LanguageContext";
import AdminLogin from "./AdminLogin";

const LOGO_URL = "/logo-sciad.png";

const MaintenancePage = ({ onAdminLogin }) => {
  const { t } = useTranslation();
  const [showLogin, setShowLogin] = useState(false);

  return (
    <div className="min-h-screen bg-[#0B1121] flex items-center justify-center relative" data-testid="maintenance-page">
      <div className="text-center px-6">
        <img src={LOGO_URL} alt="SCIAD" className="h-16 w-auto mx-auto mb-8" />
        <div className="w-16 h-16 rounded-full bg-[#00CCC2]/20 flex items-center justify-center mx-auto mb-6">
          <svg className="w-8 h-8 text-[#00CCC2]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold mb-4">
          <span className="gradient-text">{t("maintenance_title")}</span>
        </h1>
        <p className="text-slate-400 text-lg max-w-md mx-auto">{t("maintenance_msg")}</p>
      </div>

      {/* Petit cadenas en bas à droite pour accéder à l'admin */}
      <button
        onClick={() => setShowLogin(true)}
        className="fixed bottom-6 right-6 w-12 h-12 rounded-full bg-[#131B2F] border border-white/10 flex items-center justify-center hover:bg-[#2395E3]/20 hover:border-[#2395E3]/40 transition-all group"
        title="Accès administration"
        data-testid="maintenance-admin-btn"
      >
        <Lock className="w-5 h-5 text-slate-500 group-hover:text-[#2395E3] transition-colors" />
      </button>

      {showLogin && (
        <AdminLogin
          onLogin={(creds) => {
            setShowLogin(false);
            if (onAdminLogin) onAdminLogin(creds);
          }}
          onClose={() => setShowLogin(false)}
        />
      )}
    </div>
  );
};

export default MaintenancePage;
